import React from "react";
import { Row, Col, Card, CardBody } from "reactstrap";
import { Link } from "react-router-dom";
import { quicklinks } from "../constants/dashboard.constant";
import AccessControl from "../../../shared/components/AccessControl";
import { permissionsConstants } from "../../../constants/permission.constants";

const { MANAGE_USER, CREATE_DISBURSEMENT } = permissionsConstants;
const QuickLinks = () => (
    <Card>
        <CardBody>
            <Row>
                <AccessControl allowedPermissions={[MANAGE_USER]} renderNoAccess={() => null}>
                    <Col>
                        <Link className="dashboard__competitor" to={quicklinks[1].path}>
                            <div className="dashboard__competitor-icon--info mr-2">{quicklinks[1].icon({ size: 20 })}</div>
                            <div className="dashboard__competitor-info">
                                <h5 className="dashboard__competitor-name">{quicklinks[1].title}</h5>
                            </div>
                        </Link>
                    </Col>
                </AccessControl>
                <AccessControl allowedPermissions={[CREATE_DISBURSEMENT]} renderNoAccess={() => null}>
                    <Col>
                        <Link className="dashboard__competitor" to={quicklinks[0].path}>
                            <div className="dashboard__competitor-icon--info mr-2">{quicklinks[0].icon({ size: 20 })}</div>
                            <div className="dashboard__competitor-info">
                                <h5 className="dashboard__competitor-name">{quicklinks[0].title}</h5>
                            </div>
                        </Link>
                    </Col>
                </AccessControl>
            </Row>
        </CardBody>
    </Card>
);

export default QuickLinks;
